import { AIDraftStatus } from '../appointmentSummary/AppointmentSummary'

export enum AIDraftPromptType {
  INTAKE = 'PROMPT_FOR_CLIENT_INTAKE_MESSAGE_DRAFT_V1',
  POST_SESSION = 'PROMPT_FOR_POST_SESSION_MESSAGE_DRAFT_V1',
}

type BaseAIDraft = {
  id: string
  create_date: string
  status: AIDraftStatus
  summary_text: string
  patient_id: string
}

export type AIIntakeDraft = BaseAIDraft & {
  prompt_type: AIDraftPromptType.INTAKE
  assignment_id: string
}

export type AIPostSessionDraft = BaseAIDraft & {
  prompt_type: AIDraftPromptType.POST_SESSION
  note_id: string
}

export type AIDraft = AIIntakeDraft | AIPostSessionDraft
